// extracted by mini-css-extract-plugin
module.exports = {"container":"_280dd0","link":"_c5c7d0","iconColors":"_657355","iconColorsInverted":"_afd29b"};